import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import { SYSTEM } from '~~/enum/index'

dayjs.extend(utc)
dayjs.extend(timezone)
/**
 * 是否为客户端
 */
export function isClient() {
  return typeof window !== 'undefined' && !!window
}

/**
 * 是否为生成环境
 */
export const isPro = (env?: string) => env === 'production'

// 解析url参数
export function fetchUrlParams() {
  const result: IObject = {}
  const index = location.href.lastIndexOf('?')

  if (index < 0) {
    return {}
  }

  const search = location.href.slice(index + 1)
  const arr = search.split('&')
  arr.forEach((item) => {
    const param = item.split('=')
    result[param[0]] = param[1]
  })

  return result
}

/**
 * 替换文本中的a标签 href值为JavaScript:void(0) 并且把链接地址放在自定义的url字段中
 * @param {*} text
 * @returns
 */
export function replaceHtmlALink(text: string, isInnerApp: boolean) {
  // 第一个replace 匹配字符里面的a标签
  let replaceResult = text
  if (text && isInnerApp) {
    replaceResult = `${text}`.replace(/<a [^>]+>/gi, (item) => {
      // 第二个 正则 提取当前项中 a标签的href值
      const lastTagReg = />$/g
      // 补全反尖括号 前面的空格
      const waitTag = lastTagReg.test(item) ? item.replace(lastTagReg, ' >') : item
      // 标签的熟悉是以空格分开的
      const Matchs = `${waitTag}`.split(/\s/)
      // 在空格拆分的列表里面查找 href 的熟悉
      const hrefMatch = Matchs.find((item) => item.includes('href'))
      // 在href 属性中 获取连接 如果hrefMatch 没有值则证明是一个非法的a标签，直接将该a标签置空
      const urlMatchResult = hrefMatch ? `${hrefMatch}`.replace(/^(href=("|'))|('|")$/gi, '') : null
      return `<a href="javascript:void(0);" data-url="${urlMatchResult}">`
    })
  }
  return replaceResult
}

// 函数防抖
// eslint-disable-next-line @typescript-eslint/ban-types
export function debounce(fun: Function, delay = 500, immediate = true) {
  let timer: any // 保存定时器
  return function (this: unknown, ...args: any[]) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const that = this
    const _args = args
    // 不管是否立即执行都需要首先清空定时器
    if (timer) clearTimeout(timer)
    if (immediate) {
      // 如果定时器不存在,则说明延时已过,可以立即执行函数 //不管上一个延时是否完成,都需要重置定时器
      if (!timer) fun.apply(that, _args)
      timer = setTimeout(function () {
        // 到时间后,定时器自动设为null,不仅方便判断定时器状态还能避免内存泄露
        timer = null
      }, delay)
    } else {
      // 如果是非立即执行版,则重新设定定时器,并将回调函数放入其中
      timer = setTimeout(function () {
        fun.call(that, _args)
      }, delay)
    }
  }
}

// 函数节流
type ThrottleFunction = (...args: any[]) => void
export function throttle(func: ThrottleFunction, delay = 1000): ThrottleFunction {
  let timeoutId: ReturnType<typeof setTimeout> | null = null

  return function throttledFunction(this: any, ...args: any[]) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const context = this
    if (!timeoutId) {
      func.apply(context, args)
      timeoutId = setTimeout(() => {
        timeoutId = null
      }, delay)
    }
  }
}

// 是否在APP内
export function innerApp(userAgent: string) {
  if (isClient()) {
    const u = userAgent || navigator.userAgent.toLowerCase()
    return u.includes(SYSTEM.IS_APP_KEY)
  }
  return `${userAgent}`.includes(SYSTEM.IS_APP_KEY)
}

// 判断当前设备是ios还是安卓
export function appIsAndroidOrIOS(userAgent?: string) {
  const u = userAgent || navigator.userAgent
  const isAndroid = u.includes('Android') || u.includes('Adr') // android终端
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
  if (isAndroid) {
    return 'android'
  }
  if (isiOS) {
    return 'ios'
  }
  return ''
}

// 循环赋值
export function loopAssignment(targetObj: IObject, obj: IObject, arr?: string[]) {
  // 有第三个参数则按传入数组赋值，否则按obj的keys赋值
  const forArr = arr ?? Object.keys(obj)
  for (const k of forArr) {
    if (k in targetObj && k in obj) {
      targetObj[k] = obj[k]
    }
  }
}

// 字符串数组排序
export function customNumberSort(arr: string[]) {
  const numberArray = arr.map((str) => parseInt(str, 10))
  const copy = [...numberArray]
  copy.sort(function (a, b) {
    return a - b
  })
  return copy
}
// 字符串插入
export const insertStr = (soure: string, start: number, newStr: string) => {
  return soure.slice(0, start) + newStr + soure.slice(start)
}

export function joinUrlQuery(url = '', query = {}) {
  let queryString = ''
  try {
    for (const key in query) {
      if (queryString) {
        queryString = queryString + `&${key}=${query[key]}`
      } else {
        queryString = `?${key}=${query[key]}`
      }
    }
    return `${url}${queryString}`
  } catch (e) {
    console.log('拼接错误')
    return ''
  }
}

export const isFalsy = (value: any) => [0, '', false, null, undefined, NaN].includes(value)
